// extracted by mini-css-extract-plugin
export var bold = "_ro-0";